<template>

  <div>
    <el-row style="padding-top: 1.2em; padding-bottom: 0.8em;" align="middle">
      <data-table
        ref="equiptable"
        table-ref="equiptable"

        title="Sites: Equipment"
        icon="fa fa-tools"

        url="/sites"

        :fields="fields"

        sort-field="siteName"

        search-placeholder="Site Ids, Site Names, Status, Site Group..."
        detail-component="site-equip-row">

        <template slot="equip-details" slot-scope="props">
          <el-row :gutter="9.63">
            <el-col :xs="24" :sm="24" :md="24" :lg="14" :hg="14">
              <site-card style="margin-top: 0.852em;" :site-data="props.rowData" use-leaflet map-left :no-map="!isDesktop" height="230px" />
           </el-col>

           <el-col :xs="24" :sm="24" :md="24" :lg="10" :hg="10">

             <el-card shadow="hover">

               <good-table
                 :cols="getCols(props.rowData.stats)"
                 :rows="getRows(props.rowData.stats)"

                 group
                 fixed-header
                 compact
                 striped

                 :sort="false"
                 :search="false"
                 :pagination="false"

                 theme="black-rhino"
                 max-height="285px"
             />

           </el-card>

          </el-col>

         </el-row>
        </template>

      </data-table>

    </el-row>

  </div>

</template>

<script>


import Vue from 'vue'

import FormattingMixins from '@/mixins/FormattingMixins'

import SiteCard from '@/components/sites/SiteCard'
import SiteEquipView from '@/components/assets/SiteEquipView'

Vue.component('site-equip-row', SiteEquipView)

export default {
  mixins: [FormattingMixins],

  components: {
    SiteCard,
    SiteEquipView
  },

  props: {
    readOnly: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getCols(stats) {
      return [
        {
          label: 'Type',
          field: 'type'
        },
        {
          label: 'Qty.',
          field: 'qty'
        },
      ]
    },

    getRows(stats) {
      return this.getRowsBy(stats, ['service', 'asset', 'ticket', 'request'])
    },

    getRowsBy(stats, type) {
      let row = []
      let total = 0

      for (let i = 0; i < type.length; i++) {
          let ch = []

          let keys = Object.keys(stats)

          for (let k = 0; k < keys.length; k++) {

            if (keys[k].startsWith(type[i])) {

              if (stats[keys[k]]) {

                let label = (keys[k].includes('rt')
                ? (keys[k].length === 3 ? keys[k].toUpperCase() : keys[k])
                : keys[k].substring(type[i].length, keys[k].length))

                  if (keys[k] === this.plural(type[i], 2)) {
                    total = stats[keys[k]]

                  } else {

                    ch.push({type:
                      (keys[k] === this.plural(type[i], 2)
                      ? this.titleCase(keys[k])
                      : label),
                      qty: stats[keys[k]]})
                  }  // if keys[k]...

              } // if stats[keys[k]]...

            } // if keys[k].startsWith...

          } // for keys

       if (ch.length > 0) {
         row.push({mode: 'span', label: this.titleCase(this.plural(type[i], 2)) + ' (' + total + ')', children: ch})
      }

      total = 0
      } // for type

      return row
    },


  },

  data () {
    return {
      owner: this.isTelco() ? Number(this.org().id) : null,
      fields: [
        /*        {
        name: '__checkbox',
        title: '#',
        titleClass: 'has-text-centered',
        dataClass: 'has-text-centered'
        }, */
        {
          name: '__slot:equip-details'
        },
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// EquipView.vue?2d02c071